import * as React from 'react';
import { ErrorLogComponent } from '@cian/error-log-component';
import { Prelanding } from '@cian/frontend-val-my-home-banner';
import { smoothScrollIntoView, useIsDesktop } from '@cian/valuation-utils-component';
import { StickyScrollBtnContainer, useToggleStickyScrollBtn } from '../StickyScrollBtn';
import { HeroBannerLayout, HeroBannerMobile } from '../../components/HeroBanner';
import { AddNewCardLayout } from '../../components/AddNewCard';
import { FormAnnotationContainer } from '../FormAnnotationContainer';
import { MyHomeFormContainer } from '../MyHomeFormMicrofrontend';
import { FiltersMobileContainer } from '../FiltersContainer';
import { PageLayout } from '../../components/PageLayout';
import { Advantages } from '../../components/Advantages';
import { ServiceCardsContainer } from '../ServiceCards';
import { HomeProfitOnboardingContainer, NewDreamOnboardingContainer } from '../Onboarding';
import { useSaveSource } from 'shared/hooks';
import { ConsultationTrapContainer } from '../ConsultationTrap/ConsultationTrap';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const PageContainer: React.FC = () => {
  useSaveSource();
  const isDesktop = useIsDesktop();
  const { logger } = useApplicationContext();

  const containerRef = React.useRef<HTMLDivElement>(null);

  useToggleStickyScrollBtn(containerRef);

  const scrollToFilters = React.useCallback(() => {
    smoothScrollIntoView(containerRef.current as HTMLDivElement);
  }, []);

  return (
    <>
      {isDesktop ? (
        <HeroBannerLayout>
          <AddNewCardLayout
            containerRef={containerRef}
            annotation={
              <ErrorLogComponent logger={logger} errorStub={<></>}>
                <FormAnnotationContainer />
              </ErrorLogComponent>
            }
          >
            <ErrorLogComponent logger={logger} errorStub={<></>}>
              <MyHomeFormContainer />
            </ErrorLogComponent>
          </AddNewCardLayout>
        </HeroBannerLayout>
      ) : (
        <>
          <HeroBannerMobile containerRef={containerRef} />
          <ErrorLogComponent logger={logger} errorStub={<></>}>
            <FiltersMobileContainer />
          </ErrorLogComponent>
        </>
      )}

      <div data-testid="PageContainer">
        <PageLayout>
          <Advantages />
          <ErrorLogComponent logger={logger} errorStub={<></>}>
            <ConsultationTrapContainer />
          </ErrorLogComponent>
          <ServiceCardsContainer />
        </PageLayout>
      </div>

      <ErrorLogComponent logger={logger} errorStub={<></>}>
        <StickyScrollBtnContainer action={scrollToFilters} />
      </ErrorLogComponent>

      <ErrorLogComponent logger={logger} errorStub={<></>}>
        <NewDreamOnboardingContainer onFinishClick={scrollToFilters} />
      </ErrorLogComponent>
      <ErrorLogComponent logger={logger} errorStub={<></>}>
        <HomeProfitOnboardingContainer onFinishClick={scrollToFilters} />
      </ErrorLogComponent>

      <ErrorLogComponent logger={logger} errorStub={<></>}>
        <Prelanding />
      </ErrorLogComponent>
    </>
  );
};
